export default __webpack_public_path__ + "static/media/document_write.388623b7.svg";